import React from 'react';
import Heading from '../../components/core/heading';
import Paragraph from '../../components/core/paragraph';

import t from './translate';

const CrewLocked = () => (
  <div>
    <Heading center>{t('header')}</Heading>
    <Paragraph align="center">
      {t('explainer')}
      <br />
      <br />
      <strong>Tel:</strong> {t('phone')}
      <br />
      <strong>E-Mail:</strong> <a href={`mailto:${t('email')}`}>{t('email')}</a>
    </Paragraph>
  </div>
);

export default CrewLocked;
